import {CodeForm, Dialog, DialogAlignment, DialogTitle, useStorageItemValue} from "@variocube/cube-ui";
import * as React from "react";
import {useCallback} from "react";
import {style} from "typestyle";
import {Cleaner, CubeOrder, OrderStorage} from "./model";
import {useLocalization} from "../i18n";

interface CodeDialogProps {
    open: boolean;
    onClose: () => void;
    onCleaner: (cleaner: Cleaner) => void;
    onOrder: (order: CubeOrder) => void;
}

export function CodeDialog({open, onClose, onCleaner, onOrder}: CodeDialogProps) {
    const {t} = useLocalization();
    const cleaner = useStorageItemValue<Cleaner>("cleaner");
    const orders = useStorageItemValue<OrderStorage>("orders");

    const handleVerify = useCallback(async (code: string) => {
        if (!code) {
            throw new Error("Invalid code");
        }

        // check cleaner
        if (cleaner && code == cleaner?.accessCode) {
            return onCleaner(cleaner);
        }
        else {
            // check for order
            const order = orders && orders[code];
            if (order) {
                return onOrder(order);
            }
        }
        // otherwise it's an invalid code
        throw new Error("Invalid code");
    }, [cleaner, orders, onCleaner, onOrder]);

    return (
        <Dialog open={open} align={DialogAlignment.Center} onBackdropClick={onClose}>
            <div className={style({ width: "45em"})}>
                <DialogTitle>
                    {t("EnterCode")}
                </DialogTitle>
                {open && (
                    <CodeForm
                        onVerify={handleVerify}
                        onCancel={onClose}
                        strings={t}
                    />
                )}
            </div>
        </Dialog>
    );
}
